import React from 'react';
import Parser from 'html-react-parser';

type Props = {
  error: { [key: string]: any } | undefined;
};

const ErrorPane = (props: Props) => {
  const { error } = props;

  return (
    <div className="test-connection-modal__step">
      <p className="test-connection-modal__error-title">Error</p>
      {error && error.status && (
        <p className="test-connection-modal__error-status">
          {`Error Code: ${error.status}`}
        </p>
      )}
      {error && error.error && (
        <p className="test-connection-modal__error-text">
          {`Error Message: ${error && error.error}`}
        </p>
      )}
      {error && error.errors && (
        <p className="test-connection-modal__error-text">
          {error.errors.map(error => (
            <div>{Parser(error)}</div>
          ))}
        </p>
      )}
    </div>
  );
};

export default ErrorPane;
